import { useState } from "react";
import { FaPhoneAlt } from "react-icons/fa";
import { NavLink } from "react-router-dom";

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);

  const navLinks = [
    { name: "Home", path: "/" },
    { name: "About", path: "/about" },
    { name: "Services & IT Solution", path: "/services-it-solution" },
    { name: "Contact Us", path: "/contactus" },
  ];

  return (
    <nav className="w-full bg-white shadow-md sticky top-0 z-50">
      {/* MAIN CONTAINER */}
      <div
        className="relative w-full flex items-center justify-between
        px-3 lg:px-5 py-3 gap-3 md:gap-5 flex-wrap lg:flex-nowrap"
      >

        {/* LEFT – LOGO */}
        <div className="flex items-center gap-2 flex-shrink-0 pr-0">
          <img
            src="/LOGO.jpg"
            alt="logo"
            className="w-12 h-12 rounded-full object-cover" // 🔹 logo slightly smaller
          />
          <h1 className="hidden md:block text-2xl font-bold text-blue-700">
            MDC & IT Solutions
          </h1>
        </div>

        {/* CENTER – NAV LINKS (DESKTOP) */}
        <ul className="hidden lg:flex flex-1 items-center justify-center gap-4 xl:gap-6 font-semibold min-w-0">
          {navLinks.map((link, index) => (
            <li key={index}>
              <NavLink
                to={link.path}
                className={({ isActive }) =>
                  `px-4 py-2 rounded-full text-base transition
                  ${
                    isActive
                      ? "bg-blue-600 text-white"
                      : "text-gray-800 hover:bg-blue-500 hover:text-white"
                  }`
                }
              >
                {link.name}
              </NavLink>
            </li>
          ))}
        </ul>

        {/* RIGHT – CALL BUTTON (DESKTOP) */}
        <a
          href="tel:+919211413808"
          className="hidden lg:flex items-center gap-3 flex-shrink-0
          border-2 border-blue-400 px-5 py-2 rounded-full
          bg-blue-500 text-white hover:bg-indigo-500 transition"
        >
          <FaPhoneAlt />
          <span className="text-lg font-medium">+91 9211413808</span>
        </a>

        {/* HAMBURGER – MOBILE (RIGHT SIDE, SEPARATE FROM LOGO) */}
        <button
          className="lg:hidden ml-auto text-3xl text-blue-600"
          onClick={() => setIsOpen(!isOpen)}
        >
          {isOpen ? "✖" : "☰"}
        </button>
      </div>

      {/* MOBILE MENU */}
      {isOpen && (
        <div className="lg:hidden w-full bg-white shadow-lg border-t">
          <ul className="flex flex-col items-start py-4 gap-1 px-6">
            {navLinks.map((link, index) => (
              <li key={index} className="w-full">
                <NavLink
                  to={link.path}
                  onClick={() => setIsOpen(false)}
                  className={({ isActive }) =>
                    `block w-full py-2 text-lg font-semibold text-left transition
                    ${
                      isActive
                        ? "bg-blue-600 text-white"
                        : "text-gray-800 hover:bg-blue-500 hover:text-white"
                    }`
                  }
                >
                  {link.name}
                </NavLink>
              </li>
            ))}
          </ul>
        </div>
      )}
    </nav>
  );
};

export default Navbar;
